//
//
//
//
//
//
//
//
//
//
//
//
//

import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoTexto',
  props: {
    value: {
      type: [String],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    maxCaracteres() {
      const { desAtributos } = this.metadados;
      if (!desAtributos) return null;
      return desAtributos.max;
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredTime: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.valorInterno;
          return !!(val) || msg;
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoTexto.vue?vue&type=script&lang=js&